import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Toast/sgds-toast";
import { register } from "../../utils/ce-registry";

register("sgds-toast", Component);

export default createComponent({
  react: React,
  tagName: "sgds-toast",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
